import { type VFC } from 'react'

import { CSW_ON_SERP, EXPERIMENT_VARIATION } from 'shared/experiments/consts'
import { getExperiments } from 'shared/experiments/utils/experiments'
import HorizontalSliderSkeleton from 'views/components/organisms/HorizontalSliderSkeleton'
import useShopAndRuntimeConfig from 'views/enhancers/useShopAndRuntimeConfig'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

const IfShowCswInSerp: VFC<{ query: string }> = ({ query }) => {
  const {
    publicRuntimeConfig: {
      publicConfig: {
        searchConfig: { specialSearchTerms },
      },
      pageProperties: { experiments },
    },
  } = useShopAndRuntimeConfig()

  const [cswOnSerpExp] = getExperiments([CSW_ON_SERP], experiments)

  return (
    (cswOnSerpExp?.isEnabled &&
      cswOnSerpExp?.variant === EXPERIMENT_VARIATION.V1 &&
      specialSearchTerms
        ?.map(term => term.toLowerCase())
        ?.includes(query?.toLowerCase()) && (
        <li>
          <div id="csw-cro-1848">
            <HorizontalSliderSkeleton
              className="a-box--white u-border-radius u-padding"
              visibleItemCount={4}
            />
          </div>
        </li>
      )) ||
    null
  )
}

export default withShopAndRuntimeConfig(IfShowCswInSerp)
